export default {
  employeeNo: {
    required: true,
    regex: /.+/,
    tips: '请输入员工号'
  },
  userName: {
    required: true,
    regex: /.+/,
    tips: '请输入员工姓名'
  },
  password: {
    required: true,
    regex: /.{6,}/,
    tips: '请输入至少6位密码'
  },
  oldPwd: {
    required: true,
    regex: /.{6,}/,
    tips: '请输入至少6位密码'
  },
  newPwd1: {
    required: true,
    regex: /.{6,}/,
    tips: '请输入至少6位密码'
  },
  newPwd2: {
    required: true,
    regex: /.{6,}/,
    tips: '请输入至少6位密码'
  },
  phone: {
    required: true,
    regex: /^1\d{10}$/,
    tips: '请输入首位是1且11位的手机号'
  },
  Verification: {
    required: true,
    regex: /^\d{6}$/,
    tips: '请输入6位的验证码'
  }
}



// WEBPACK FOOTER //
// ./src/pg/scheme.js